import Inputs from 'components/Inputs'
import { on } from 'events'
import { useState } from 'react'
import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'

const Question = ({
  data,
  onChange,
  answer,
  inverted = false,
  titleOnly = false,
  questionNumber = 0,
}: {
  data: Question
  onChange: (
    id: string,
    value: string | number,
    questionNumber?: number
  ) => void
  answer: string | number | undefined
  inverted?: boolean
  titleOnly?: boolean
  questionNumber?: number
}) => {
  const { question, id } = data
  const [answered, setAnswered] = useState(answer !== undefined)
  const windowSize = useWindowSize()
  const isMobile = windowSize.width < 712
  // if (answer!==undefined) setAnswered(true)

  const handleAnswer = (
    id: string,
    value: string | number,
    questionNumber?: number
  ) => {
    setAnswered(true)
    onChange(id, value, questionNumber)
  }

  return (
    <QuestionRoot
      id={'q' + questionNumber}
      $titleOnly={titleOnly}
      $noTitle={!questionNumber && !isMobile}
    >
      {!!questionNumber && (
        <Title>
          <QuestionNumber
            style={{
              color: answered ? 'var(--purple-main)' : 'unset',
              fontSize: answered ? '22px' : '14px',
            }}
          >
            {answered ? <>&#10003;</> : questionNumber}
          </QuestionNumber>{' '}
          {question}
        </Title>
      )}
      {!titleOnly && (
        <Inputs
          questiondata={data}
          onChange={handleAnswer}
          value={answer}
          inverted={inverted}
          questionNumber={questionNumber}
          title={questionNumber ? undefined : question}
        />
      )}
    </QuestionRoot>
  )
}

const QuestionNumber = styled.div`
  font-weight: 300;
  font-size: 15px;
  float: left;
  margin-right: 5px;
  position: relative;
  width: 26px;
  text-align: center;
`
const QuestionRoot = styled.div<{ $titleOnly: boolean; $noTitle: boolean }>`
  margin-bottom: ${(props) => (props.$titleOnly ? '30px' : '90px')};
  padding-left: ${(props) => (props.$noTitle ? '60px' : '0px')};
  max-width: 668px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  z-index: 30;
`

const Title = styled.h3`
  line-height: 1.2em;
  font-size: 18px;
  display: flex;
  align-items: flex-start;
  @media screen and (max-width: 712px) {
    font-size: 18px;
  }
`
export default Question
